import { t } from 'i18next'

import { ResidentAppError } from '../../../../common/error'
import { PaymentTypeCategory } from '../../../../common/validations/paymentCategory'

export const useResolvePaymentCategory = () => {
  const resolvePaymentCategory = (category: PaymentTypeCategory) => {
    switch (category) {
      case PaymentTypeCategory.CHARGES_FOR_UTILITIES:
        return t('payments:paymentTypeCategory.chargesForUtilities')
      case PaymentTypeCategory.GENERIC:
        return t('payments:paymentTypeCategory.generic')
      case PaymentTypeCategory.INTEREST:
        return t('payments:paymentTypeCategory.interest')
      case PaymentTypeCategory.RENT:
        return t('payments:paymentTypeCategory.rent')
      case PaymentTypeCategory.RESIDENCE_CHARGE:
        return t('payments:paymentTypeCategory.residenceCharge')
      case PaymentTypeCategory.RIGHT_OF_OCCUPANCY_DEPOSIT:
        return t('payments:paymentTypeCategory.rightOfOccupancyDeposit')
      case PaymentTypeCategory.RIGHT_OF_OCCUPANCY_NEW_DEVELOPMENT_DEPOSIT:
        return t(
          'payments:paymentTypeCategory.rightOfOccupancyNewDevelopmentDeposit'
        )
      case PaymentTypeCategory.SECURITY_DEPOSIT:
        return t('payments:paymentTypeCategory.securityDeposit')
      default: {
        throw ResidentAppError.ClientError('UNKNOWN', {
          message: `Unknown payment category: ${category}`,
        })
      }
    }
  }

  return { resolvePaymentCategory }
}
